export default "__VITE_ASSET__CCEDLzWf__"